type Mixin<T extends any[]> = T extends [infer F, ...infer R] ? F & Mixin<R> : unknown;

interface Klass<T> {
  new (...args: any[]): T;
}

export const mixin = <T extends any[]>(...args: T): Klass<Mixin<T>> => {
  const c = class {};
  Object.defineProperty(c, 'name', {
    value: 'Mixin<' + args.map((a) => a.name).join(',') + '>',
  });
  args.forEach((arg) =>
    Object.defineProperties(c.prototype, Object.getOwnPropertyDescriptors(arg))
  );

  return c as Klass<Mixin<T>>;
};
